<template>
  <b-row>
    <b-col>
      <b-row>
        <b-col cols="12">
          <span class="h6">{{$t("views.agreements.form.agreementsConsents")}}: </span>
        </b-col>
        <b-col cols="12">
          <div class="btn-group">
            <button v-if="visible === false" aria-controls="consents_collapse" class="btn btn-sm" @click="visible = true" type="button"> {{ $t('buttons.expand') }} </button>
            <button v-else aria-controls="consents_collapse" class="btn btn-sm" @click="visible = false" type="button"> {{ $t('buttons.fold') }} </button>
            <button type="button" @click="acceptAllConsents()" class="btn btn-sm btn-success">
              {{$t('buttons.acceptAllConsents')}}
            </button>
            <button type="button" @click="discardAllConsents()" class="btn btn-sm btn-success">
              {{$t('buttons.clearAllConsents')}}
            </button>
          </div>
        </b-col>
      </b-row>
      <b-collapse id="consents_collapse" v-model="visible">
        <div class="row mgcorrect pdcorrect">
          <b-card class="no-shadow bordered no-height100 col-sm-12 col-lg-12" v-for="(item, index) in data.agreementsConsents" v-bind:key="index" :id="'AgreementsConsents-' + index">
            <div class="row mgcorrect pdcorrect">
              <div v-if="item" class="col-sm-12 col-lg-12">
                <p class="m-0" ><b>{{item.consent.title}}</b></p>
                <small>{{item.consent.description}}</small>
                <div class="form-group mt-4" v-if="item.consent.requireConsent !== 1">
                  <label>{{$t("views.agreements.form.agree")}}:
                  <b-form-group>
                    <b-form-radio-group buttons button-variant="outline-primary" v-model="item.agree" size="sm">
                      <b-form-radio button-variant="outline-success" :value="2">{{$t("views.agreements.form.agree")}}</b-form-radio>
                      <b-form-radio button-variant="outline-danger" :value="1">{{$t("views.agreements.form.noagree")}}</b-form-radio>
                    </b-form-radio-group>
                  </b-form-group>
                  </label>
                </div>
                <div class="form-group mt-4" v-if="item.consent.requireConsent === 1">
                  <p><b>{{$t("views.agreements.form.agreeRequired")}}</b></p>
                </div>
              </div>
            </div>
          </b-card>
        </div>
      </b-collapse>
    </b-col>
  </b-row>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ApiService from '@/utils/ApiService'

export default {
  name: 'AgreementConsents',
  data () {
    return {
      visible: false,
      consents: []
    }
  },

  props: ['data', 'violations'],

  computed: {
    ...mapGetters({
      agreementConsents: 'agreements/create/getAgreementConsents'
    })
  },

  created () {
    if (!this.data['@id']) {
      this.fetchConsentsForAgreement()
    }
  },

  methods: {
    async fetchConsentsForAgreement () {
      let baseParams = { pagination: false, consentType: 0 }
      const response = await new ApiService('e_x_c_m_consents', baseParams).getResults()
      response.items = response.items.map(entry => {
        return {
          agree: 0,
          consent: {
            '@id': entry['@id'],
            title: entry.title,
            description: entry.description,
            requireConsent: entry.requireConsent
          }
        }
      })
      this.setAgreementConsents(response.items)
    },
    acceptAllConsents () {
      this.data.agreementsConsents.forEach((consent) => {
        consent.agree = 2
      })
    },
    discardAllConsents () {
      this.data.agreementsConsents.forEach((consent) => {
        consent.agree = 0
      })
    },
    setAgreementConsents (consents) {
      this.data.agreementsConsents = consents
    },
    ...mapActions({
      fetchConsents: 'agreements/create/fetchConsentsForAgreement'
    })
  }
}
</script>

<style scoped>

</style>
